var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12073_117311",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 24,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1H24V23H0V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12073_117311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1419 6.69236C19.5742 3.98283 16.6446 2.1598 13.2891 2.1598V11.2262L21.1419 15.76C21.9136 14.4263 22.3555 12.8779 22.3555 11.2262C22.3555 9.57449 21.9136 8.02611 21.1419 6.69236Z",
    stroke: "#6F767E",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7109 12.7734V3.70703C7.35538 3.70703 4.42586 5.53007 2.8581 8.23959C2.08642 9.57334 1.64453 11.1217 1.64453 12.7734C1.64453 14.4251 2.08642 15.9735 2.8581 17.3073C4.42586 20.0168 7.35538 21.8398 10.7109 21.8398C14.0665 21.8398 16.996 20.0168 18.5638 17.3073L10.7109 12.7734Z",
    stroke: "#6F767E",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.946e0b3305fb0c02be20e0857390d7bd.svg";
export { ForwardRef as ReactComponent };